import Stack from '@mui/material/Stack';
import { ReactNode } from 'react';
import { BoxProps } from '@mui/material/Box';
import { SxProps, useTheme } from '@mui/material/styles';
import { TimelineIcon } from '@/common/components/timeline/subcomponents/timeline-icon/TimelineIcon.tsx';
import { TimelineIconGroup } from '@/common/components/timeline/subcomponents/timeline-icon-group/TimelineIconGroup.tsx';
import { TimelineContext } from '@/common/components/timeline/TimelineContext.ts';
import { TimelineItem } from '@/common/components/timeline/subcomponents/timeline-item/TimelineItem.tsx';
import { TimelineLineBadge } from '@/common/components/timeline/subcomponents/timeline-line-badge/TimelineLineBadge.tsx';
import { TimelineLoadMore } from '@/common/components/timeline/subcomponents/timeline-load-more/TimelineLoadMore.tsx';
import { TimelineLoading } from '@/common/components/timeline/subcomponents/timeline-loading/TimelineLoading.tsx';
import { TimelineError } from '@/common/components/timeline/subcomponents/timeline-error/TimelineError.tsx';
import { TimelineItemSkeleton } from '@/common/components/timeline/subcomponents/timeline-item-skeleton/TimelineItemSkeleton.tsx';

export interface TimelineProps {
  backgroundColor?: string;
  sx?: SxProps;
  leftContentProps?: BoxProps;
  children?: ReactNode;
  lineColor?: string;
}

export const Timeline = ({
  backgroundColor,
  sx,
  leftContentProps,
  children,
  lineColor,
}: TimelineProps) => {
  const theme = useTheme();
  const backgroundColorOrDefault = backgroundColor ?? theme.palette.background.default;

  return (
    <TimelineContext
      value={{
        backgroundColor: backgroundColorOrDefault,
        leftContentProps: leftContentProps,
        lineColor: lineColor ?? theme.palette.divider,
      }}
    >
      <Stack position="relative" sx={{ backgroundColor: backgroundColorOrDefault, ...sx }}>
        {children}
      </Stack>
    </TimelineContext>
  );
};

Timeline.Icon = TimelineIcon;
Timeline.IconGroup = TimelineIconGroup;
Timeline.Item = TimelineItem;
Timeline.LineBadge = TimelineLineBadge;
Timeline.LoadMore = TimelineLoadMore;
Timeline.Loading = TimelineLoading;
Timeline.Error = TimelineError;
Timeline.ItemSkeleton = TimelineItemSkeleton;
